import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AllApplicantsActions} from 'src/action-creators/analytics/analytics-all-applicants';
import type {
  AllApplicantsFilters,
  SavedDashboardList,
  SelectedAllApplicantsTableFilterColumnsData,
} from 'src/types/analytics-genesis';

import {
  CLEAR_SELECTED_FILTERS,
  SET_SELECTED_DATE_RANGE,
  RECEIVE_SAVED_DASHBOARDS,
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_FILTERS,
  RECEIVE_ALL_APPLICANTS_TABLE_COLUMNS,
  RECEIVE_TABLE_FILTER_COLUMNS,
} from 'src/action-creators/analytics/analytics-all-applicants';


export type AllApplicantsState = {
  savedDashboards: SavedDashboardList;
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  selectedFilters: AllApplicantsFilters;
  allApplicantsTableColumnFilter: SelectedAllApplicantsTableFilterColumnsData | null;
};

const initialState: AllApplicantsState = {
  selectedFilters: {
    job_id: [],
    job_department: [],
    job_location: [],
    job_source: [],
    job_recruiter: [],
    milestone: [],
  },
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  allApplicantsTableColumnFilter: null,
  savedDashboards: [],
  currentDashboardID: null,
};

export default (
  state: AllApplicantsState = initialState,
  action: AllApplicantsActions,
): AllApplicantsState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }

    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }

    case SET_SELECTED_FILTERS: {
      const {selectedFilters} = state;
      return {
        ...state,
        selectedFilters: {
          ...selectedFilters,
          ...action.payload,
        },
      };
    }

    case CLEAR_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          job_id: [],
          job_department: [],
          job_location: [],
          job_source: [],
          job_recruiter: [],
          milestone: [],
        },
      };
    }
    case RECEIVE_ALL_APPLICANTS_TABLE_COLUMNS: {
      return {...state, allApplicantsTableColumnFilter: action.payload};
    }
  }

  return state;
};
